export const smTitle = {
  SUBCONTRACTOR_APP: 'Subcontractor App',
};
